/**
 * An empty function definition. This is useful for specifying default callbacks or as a default constructor.
 *
 * @example
 * const defaultCallback = ({ callback = noop }) => { ... };
 * const defaultConstructor = new Proxy(noop, { construct: () => { name: 'Frank Smith' } });
 */
export function noop(): void {
    /**
     * This function must not be converted into an arrow function because
     * otherwise you can't use it as a default constructor
     */
}
